<div class="page-header"><div class="main"><h1><slot></slot></h1></div><div class="extra"><slot name="extra"></slot></div></div>